import { useLightningLayerEnabled } from 'features/mapping/hooks/useLightningLayerEnabled';

export type LightningTimelineLookbackHours = 48 | 72;

/**
 * 72h internal, 48h external. Only used when `showLightningLayer` is true, and
 * the two permissions are exclusive, so "not internal" means external.
 */
export const useLightningTimelineLookbackHours =
  (): LightningTimelineLookbackHours => {
    const { showInternalLightningLayer } = useLightningLayerEnabled();
    return showInternalLightningLayer ? 72 : 48;
  };
